namespace Areas {
    "use strict";

    export function addFilterBuilder(e: any) {
        const grid: DevExpress.ui.dxDataGrid = e.component;

        let filterBuilder = new FilterBuilder(grid, e.toolbarOptions);
        filterBuilder.addButtons();
    }

}